import { apiFetch } from './auth-service';

export interface MentoringRequestDoc {
  _id: string;
  founderId: any;
  mentorId: any;
  scheduledAt: string;
  startTime: string;
  endTime: string;
  status: 'pending' | 'accepted' | 'rejected' | 'expired' | 'scheduled';
  requestedAt: string;
  respondedAt: string | null;
  sessionId: any;
}

export const bookSlot = (
  mentorId: string,
  scheduledAt: string,
  startTime: string,
  endTime: string,
): Promise<MentoringRequestDoc> =>
  apiFetch.post('/mentoring-requests', { mentorId, scheduledAt, startTime, endTime });

export const getMyRequests = (): Promise<MentoringRequestDoc[]> =>
  apiFetch.get('/mentoring-requests/mine');

export const getIncomingRequests = (): Promise<MentoringRequestDoc[]> =>
  apiFetch.get('/mentoring-requests/incoming');

export const getAllRequests = (): Promise<MentoringRequestDoc[]> =>
  apiFetch.get('/mentoring-requests');

export const acceptRequest = (id: string): Promise<MentoringRequestDoc> =>
  apiFetch.patch(`/mentoring-requests/${id}/accept`, {});

export const rejectRequest = (id: string): Promise<MentoringRequestDoc> =>
  apiFetch.patch(`/mentoring-requests/${id}/reject`, {});

export const adminSchedule = (id: string): Promise<MentoringRequestDoc> =>
  apiFetch.patch(`/mentoring-requests/${id}/schedule`, {});
